var _path, _path2, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgParkSolidColor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_170_14064)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_170_14064",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 29,
    height: 28
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.2994 2.44959L2.57483 13.1742C2.35611 13.393 2.23325 13.6896 2.23325 13.999C2.23325 14.3084 2.35611 14.6051 2.57483 14.8238L13.3 25.549C13.5188 25.7677 13.8155 25.8906 14.1248 25.8906C14.4342 25.8906 14.7309 25.7677 14.9497 25.549L25.6742 14.8244C25.893 14.6056 26.0158 14.3089 26.0158 13.9996C26.0158 13.6902 25.893 13.3935 25.6742 13.1748L14.9491 2.44901C14.7303 2.23029 14.4336 2.10742 14.1242 2.10742C13.8149 2.10742 13.5182 2.23029 13.2994 2.44901V2.44959Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 4,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 14H17.5M14 10.5V17.5",
    stroke: "black",
    strokeWidth: 4,
    strokeLinecap: "round"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_170_14064)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0H28V28H0V0Z",
    fill: "#84E1CC"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_170_14064"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgParkSolidColor);
export default __webpack_public_path__ + "static/media/park-solid-color.0aa31b1e09890763d4fa19d7ba5ae098.svg";
export { ForwardRef as ReactComponent };